<style lang="scss" scoped>
.back_form {
  &-key {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262626;
    padding: 25px 55px;
    line-height: 22px;
    &_m {
      color: #e62412;
    }
  }
  &-input {
    margin-top: 8px;
    margin-bottom: 16px;
  }
  .input-m {
  }
}
.solt-view {
  // padding: 0 50px;
  display: flex;
  justify-content: space-evenly;
  text-align:center;
  margin-top: 30px;
  .imgBox {
    width: 220px;
    // flex:1;
    img{
      width:200px;
      margin-bottom: 10px;
    }
  }
}
.qw_qrcode {
  // position: absolute;
  // left: 150px;
  // top: 230px;
  // flex:2;
  
  margin: 100px 100px 0 100px;
  &_text {
    // background: #fff;
    // height: 100px;
    // text-align: center;
    margin-top: 20px;
  }
}
.URLBox {
  display: flex;
  height: 48px;

  line-height: 44px;

  .URL {
    width: 100%;
    margin-right: 16px;
    background: #f2fbff;
    border-radius: 4px;
    padding: 0 15px;
    min-width: 600px;
    border: 1px solid #ccecff;
  }
}
</style>
<template>
  <div>
    <FormHead style="margin-top: 50px" :images="require('@/assets/img/qwLogin/two.png')" />
    <BtnBar style="margin-top: 150px" title="第二步 代开发授权添加" desc="配置完成去使用" />
    <!-- 一 -->
    <Block
      :title="block1.title"
      :desc="block1.desc"
      :images="block1.images"
      style="position: relative"
    >
      <template v-slot:form class="back_form">
        <div class="solt-view">
          <div class="qw_qrcode">
            <div id="qrcode"></div>
            <div class="qw_qrcode_text">使用企微扫一扫</div>
          </div>
          <div class="imgBox">
            <img src="@/assets/img/qwLogin/configApp/step1_1.jpg" alt="" />
          </div>
          <div class="imgBox">
            <img src="@/assets/img/qwLogin/configApp/step1_2.jpg" alt="" />
          </div>
          <div class="imgBox">
            <img src="@/assets/img/qwLogin/configApp/step1_3.jpg" alt="" />
          </div>
        </div>
      </template>
    </Block>
    <!-- 二 -->
    <Block :title="block2.title" :desc="block2.desc" :images="block2.images">
      <template v-slot:form class="back_form">
        <div class="solt-view">
        <div class="imgBox">
          <img src="@/assets/img/qwLogin/configApp/step2_1.jpg" alt="" />
          <div>点击代开发完成通知</div>
        </div>
        <div class="imgBox">
          <img src="@/assets/img/qwLogin/configApp/step2_2.jpg" alt="" />
          <div>查看应用并点击可见范围选项</div>
        </div>
        <div class="imgBox">
          <img src="@/assets/img/qwLogin/configApp/step2_3.jpg" alt="" />
          <div>添加应用的可见范围</div>
        </div>
        <div class="imgBox">
          <img src="@/assets/img/qwLogin/configApp/step2_4.jpg" alt="" />
          <div>选择指定部门组织</div>
        </div>
        </div>
      </template>
    </Block>
    <Block :title="block3.title" :desc="block3.desc" :images="block3.images">
      <template v-slot:form class="back_form">
        <div class="solt-view">
        <div class="imgBox">
          <img src="@/assets/img/qwLogin/configApp/step3_1.jpg" alt="" />
          <div>点击授权申请通知</div>
        </div>
        <div class="imgBox">
          <img src="@/assets/img/qwLogin/configApp/step3_2.jpg" alt="" />
          <div>确认所需授权并授权</div>
        </div>
        <div class="imgBox">
          <img src="@/assets/img/qwLogin/configApp/step3_3.jpg" alt="" />
          <div>授权完成</div>
        </div>
        </div>
      </template>
    </Block>
    <BtnBar style="margin-top: 0" title="第二步 代开发授权添加" desc="配置完成去使用" />
    <FootBar />
  </div>
</template>

<script>
import FormHead from './comps/form/head'
import Block from './comps/form/block'
import FootBar from './comps/form/footBar'
import BtnBar from './comps/form/btnBar'
import { mapGetters } from 'vuex'
import { getInitInfo, getQWQrode } from '@/api/qwAuth'
import { createQrcode } from '@/utils'
export default {
  components: {
    FormHead,
    Block,
    FootBar,
    BtnBar
  },
  data() {
    return {
      QrUrl: '',
      InitInfo: {},
      form: {
        aes_key: null,
        token: null
      },
      loading: null,
      block1: {
        title: `一、授权代开发自建应用`,
        desc: '1、企业微信管理员扫下面二维码，并按照下图示例授权并添加代开发自建应用',
        images: null
      },

      block2: {
        title: `二、设置应用可见范围`,
        desc: '2、代开发授权添加完成后，请告知商派客服人员，待商派提交上线，上线成功后会发送企业微信通知至企业微信管理员，点击通知进入应用详情，更改应用的可见范围，授权指定部门的使用权限。',
        images: null
      },
      block3: {
        title: `三、企业微信权限授权应用`,
        desc: '3、应用上线仅保有基础权限，为了保障导购生意助手及云店营销中心功能的正常使用，商派会申请客户联系、及组织人员权限，在收到企业微信变更权限通知后，请确认权限并同意授权。',
        images: null
      }
    }
  },
  computed: {
    ...mapGetters(['companyConfig'])
  },
  created() {
    // this.getQWQrode()
    // this.getInitInfo()
  },
  mounted() {
    this.getQrUrl()
    // if(this.QrUrl)this.drawQrCode()
  },

  methods: {
    onCopy(text = '') {
      this.$copyText(text).then(
        (res) => {
          return this.$message.success('复制成功')
        },
        (err) => {
          return this.$message.error('复制失败')
        }
      )
    },

    getQrUrl() {
      getQWQrode().then((res) => {
        console.log('getQrUrl', res)
        // this.QrUrl = res.qrcode_url
        this.drawQrCode(res.qrcode_url)
      })
    },
    drawQrCode(qrcode_url) {
      createQrcode('qrcode', { text: qrcode_url })
    },
    subConfig() {
      this.$store.commit('SETCompanyConifg', {
        key: 'external_contact',
        val: Object.assign(this.companyConfig.external_contact, this.form)
      })
      // this.$router.push({ path: '/qwAuth/createdContacts' })
      this.$router.push({ path: '/' })
    },
    formInput(key) {
      // console.log(key,this.form[key])
    },
    touchUrl(Url) {
      window.open(Url)
    },
    async getInitInfo() {
      getInitInfo().then((res) => {
        console.log('getInitInfo-res', res)
        this.InitInfo = res
        this.form.token = res.external_contacts_token
        this.form.aes_key = res.external_contacts_aeskey
      })
    }
  }
}
</script>
